import { filters } from './../../models/pages/addedActivityFiles';
import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/qrPolling';
import * as qrPollingPageAction from '../actions/qrPolling';
// import { SecurityContextType, MessageState } from '../../models/components/announcement.d';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';

import Translator from '../../core/i18n';
import { IAddStudent, IAttendanceCounts, IAttendanceList, IAttendanceStudentsList, IClassess, ICreateQrCodeForAttendance, IDeletedAttendance, IEndAttendance, IGenerateQrCode, IGetActiveAttendance } from '../../models/action/qrPolling';
import { QrPollingService } from '../../api/qr-polling-service';

const T = Translator.create();
const _logger = Log.create('question Saga');
const _qrpollingservie = new QrPollingService();



function* getAttendaceList(params: IAttendanceList) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestGetAttendaceListsAsync({ ClassId: params.ClassId, Page: params.Page, Take: params.Take, Query: params.Query, OrderBy: params.OrderBy })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            yield put(qrPollingPageAction.SetAttendancesList(pageData.results, pageData.filters, params.spinnerId ?? '', 'set'));

            if (params.callback) {
                params.callback("success")
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* deleteAttendance(params: IDeletedAttendance) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestDeleteAttendace({ AttendanceIds: params.selectedAttendanceIds, ClassId: params.classId, IsAll: params.isAll })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData;
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            if (params.callback) {
                params.callback("success")
            }
            Notification.setNotification('success', T.t('r_success_deleted_attendances'), 'topRight');
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}


function* CreateQrCodeForAttendance(params: ICreateQrCodeForAttendance) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestCreateQrCodeForAttendance({ CurrentClassId: params.currentClassId, ClassIds: params.ClassIds, CourseId: params.CourseId })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            yield put(qrPollingPageAction.SetQrCodeForAttendance(pageData.attendanceId, pageData.attendanceGuid, pageData.attendanceExpirationDate, params.spinnerId ?? '', 'set'));

            if (params.callback) {
                params.callback("success")
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* GenerateQrCode(params: IGenerateQrCode) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestGenerateQrCode({ classId: params.classId, sessionId: params.sessionId })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            yield put(qrPollingPageAction.SetGenerateQrCode(pageData.qrCode, params.spinnerId ?? '', 'set'));

            if (params.callback) {
                params.callback("success")
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* GetAttendanceStudentsList(params: IAttendanceStudentsList) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestAttendanceStudentsList({ ClassId: params.ClassId, AttendanceId: params.AttendanceId, AttendanceGuid: params.AttendanceGuid, AttendanceStatus: params.AttendanceStatus, AttendanceExpirationDate: params.AttendanceExpirationDate, ...params.Filters })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {

            const attendanceCounts = {
                joinedStudentCount: pageData.joinedStudentCount,
                notJoinedStudentCount: pageData.notJoinedStudentCount,
                totalStudentCount: pageData.filters.total
            }
            const newFilters = {
                ...pageData.filters,
                total: params.AttendanceStatus === null ? pageData.filters.total : params.AttendanceStatus === 0 ? pageData.joinedStudentCount : pageData.notJoinedStudentCount
            }

            yield put(qrPollingPageAction.SetAttendanceStudentsList(pageData.results, newFilters, attendanceCounts, params.spinnerId ?? '', 'set'));

            if (params.callback) {
                params.callback("success")
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}


function* AddStudentToAttendance(params: IAddStudent) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestAddStudentAttendance({ UserIds: params.UserIds, ClassId: params.ClassId, AttendanceId: params.AttendanceId, AttendanceGuid: params.AttendanceGuid })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData;
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;
        if(params.StudentListType === null)
            yield put(qrPollingPageAction.RefreshAttendanceUserList(params.UserIds, params.StudentListType, "add"));

        if (!isError) {

            if (params.callback) {
                params.callback("success")
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* RemoveStudentToAttendance(params: IAddStudent) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestRemevoStudentAttendance({ UserIds: params.UserIds, ClassId: params.ClassId, AttendanceId: params.AttendanceId, AttendanceGuid: params.AttendanceGuid })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData;
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;
        
        if(params.StudentListType === null)
            yield put(qrPollingPageAction.RefreshAttendanceUserList(params.UserIds, params.StudentListType, "remove"));

        if (!isError) {

            if (params.callback) {
                params.callback("success")
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* GetRefreshGeneralAttendance() {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestGetRefreshAttendanceUser()
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            let attendanceCounts: IAttendanceCounts = {
                joinedStudentCount: pageData.joinedStudentCount,
                notJoinedStudentCount:pageData.notJoinedStudentCount,
                totalStudentCount: pageData.notJoinedStudentCount + pageData.joinedStudentCount
            }
            yield put(qrPollingPageAction.SetRefreshAttendanceByApi(pageData.refreshUsers, attendanceCounts))
            //yield put(qrPollingPageAction.SetClassess(pageData));

        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

    } catch (error: any) {
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* GetClassess(params: IClassess) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestGetClassess({ CourseId: params.CourseId, SearchedText: "", SelectedIds: [], Skip: 0, Take: 9999 })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            yield put(qrPollingPageAction.SetClassess(pageData));

            if (params.callback) {
                params.callback("success")
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

    } catch (error: any) {
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* GetActiveAttendanceAfterRequest(isError: boolean, pageData: any, params:any, errorList: any){
    if (!isError) {
        if(pageData)
        {
            yield put(qrPollingPageAction.SetQrCodeForAttendance(pageData.attendanceId, pageData.attendanceGuid, pageData.attendanceExpirationDate, params.spinnerId ?? '', 'set'));

            if (params.callback) {
                params.callback("success")
            }
        }else{
            yield put(qrPollingPageAction.SetQrCodeForAttendance('', '', new Date(), '', 'set'));
            yield put(qrPollingPageAction.SetGenerateQrCode(null, params.spinnerId ?? '', 'set'));

        }
        
    } else {
        Object.keys(errorList).forEach((key: any) => {
            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
        });
    }

    if (params.spinnerId) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
    }
}

function* GetActiveAttendance(params: IGetActiveAttendance) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _qrpollingservie.RequestGetActiveAttendance({ classId: params.classId})
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200 && responseData.status !== 204 ) {
                    isError = true;
                }
                if(responseData.status === 204)
                    return null;
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        yield GetActiveAttendanceAfterRequest(isError, pageData, params, errorList);

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* EndAttendance(params: IEndAttendance) {
    let isError = false;
    let errorList: any;

    try {
        const _yield = _qrpollingservie.RequestEndAttendance(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                
                return responseData;
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } 
            });
        yield _yield;

        if (!isError) {
            yield put(qrPollingPageAction.SetQrCodeForAttendance('', '', new Date(), '', 'set'));

            if (params.callback) {
                params.callback("success")
            }
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* watchAttendanceList() {
    yield takeEvery(constants.actions.GET_ATTENDANCES_LIST, getAttendaceList);
    return null;
}

function* watchDeleteAttendance() {
    yield takeEvery(constants.actions.DELETE_ATTENDANCE, deleteAttendance);
    return null;
}

function* watchCreateQrCodeForAttendance() {
    yield takeEvery(constants.actions.CREATE_QR_CODE_ATTENDANCE, CreateQrCodeForAttendance);
    return null;
}

function* watchGenerateQrCode() {
    yield takeEvery(constants.actions.GENERATE_QR_CODE, GenerateQrCode);
    return null;
}

function* watchGetAttendanceStudentsList() {
    yield takeEvery(constants.actions.GET_ATTENDANCE_STUDENTS_LİST, GetAttendanceStudentsList);
    return null;
}

function* watchAddStudentToAttendance() {
    yield takeEvery(constants.actions.ADD_STUDENT_TO_ATTENDANCE, AddStudentToAttendance);
    return null;
}

function* watchRemoveStudentToAttendance() {
    yield takeEvery(constants.actions.REMOVE_STUDENT_TO_ATTENDANCE, RemoveStudentToAttendance);
    return null;
}

function* watchGetRefreshGeneralAttendance() {
    yield takeEvery(constants.actions.GET_REFRESH_GENERAL_ATTENDANCE_USER, GetRefreshGeneralAttendance);
    return null;
}

function* watchGetClassess() {
    yield takeEvery(constants.actions.GET_CLASSESS, GetClassess);
    return null;
}

function* watchGetActiveAttendance() {
    yield takeEvery(constants.actions.GET_ACTIVE_ATTENDANCE, GetActiveAttendance);
    return null;
}

function* watchEndAttendance() {
    yield takeEvery(constants.actions.END_ATTENDANCE, EndAttendance);
    return null;
}

export function* QrPollingSagas() {
    yield all([
        watchAttendanceList(),
        watchCreateQrCodeForAttendance(),
        watchGenerateQrCode(),
        watchGetAttendanceStudentsList(),
        watchDeleteAttendance(),
        watchAddStudentToAttendance(),
        watchRemoveStudentToAttendance(),
        watchGetRefreshGeneralAttendance(),
        watchGetClassess(),
        watchGetActiveAttendance(),
        watchEndAttendance()
    ]);
}